// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomSearch_wrapper__KgvWZ","input":"CustomSearch_input__+1aCE"};